module.exports = __webpack_public_path__ + "static/media/codeMario.169d7d53.png";